import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SocialIcon } from "react-social-icons";
import { FaViber } from "react-icons/fa";

const Header = () => {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header className="header-section">
      <div className="top-nav">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <ul className="tn-left" style={{ display: "inline-flex" }}>
                <li>
                  <i className="fa fa-phone"></i>
                  <a href="tel:+302254026424">+30 2254026424</a>
                </li>
                <li>
                  <a href="tel:+306981583591">+30 6981583591</a>
                  <SocialIcon
                    url="https://wa.me/306981583591"
                    style={{ height: 30, width: 30, marginLeft: 10 }}
                  />
                  <a
                    href="viber://chat?number=306981583591"
                    style={{
                      height: 30,
                      width: 30,
                      borderRadius: "50%",
                      background: "#7360F2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginLeft: 10,
                    }}
                  >
                    <FaViber size={14} color="white" />
                  </a>
                  <SocialIcon
                    target="_blank"
                    rel="noopener noreferrer"
                    url="https://www.facebook.com/rafkonapartmentslxs/"
                    style={{ height: 30, width: 30, marginLeft: 10 }}
                  />
                  <SocialIcon
                    target="_blank"
                    rel="noopener noreferrer"
                    url="https://www.instagram.com/rafkon_apartments/"
                    style={{ height: 30, width: 30, marginLeft: 10 }}
                  />
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="tn-right">
                <div className="top-social">
                  {/* <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/rafkonapartmentslxs/"
                  >
                    <i className="fa fa-facebook"></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/rafkon_apartments/"
                  >
                    <i className="fa fa-instagram"></i>
                  </a> */}
                  {/* <i className="fa fa-envelope"></i>
                  <a href="mailto:rafkonoe@gmail.com">rafkonoe@gmail.com</a> */}
                </div>
                <a
                  href="https://g.page/r/CVeeXJ1IN283EBM/review"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bk-btn"
                >
                  <img src="./img/3.png" alt="Review us on Google" />
                </a>
                <div className="language-option">
                  <img src={`./icons/${language}.png`} alt="" />
                  <span>
                    {language.toUpperCase()}{" "}
                    <i className="fa fa-angle-down"></i>
                  </span>
                  <div className="flag-dropdown">
                    <ul>
                      <li>
                        <button
                          style={{
                            borderStyle: "none",
                            backgroundColor: "transparent",
                          }}
                          onClick={() =>
                            changeLanguage(language === "en" ? "gr" : "en")
                          }
                        >
                          {language === "en" ? "GR" : "EN"}
                          <span className="spanLanguage"></span>
                          <img
                            src={`./icons/${
                              language === "en" ? "gr" : "en"
                            }.png`}
                            alt=""
                          />
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="menu-item">
        <div className="container">
          <div className="row">
            <div className="col-lg-2">
              <div className="logo">
                <Link to="/">
                  <img src="./logo.png" alt="RafKon Logo" />
                </Link>
              </div>
            </div>
            <div className="col-lg-10">
              <div className="nav-menu">
                <nav className="mainmenu">
                  <ul>
                    <li>
                      <Link to="/">{t("header.home")}</Link>
                    </li>
                    <li>
                      <Link to="/about">{t("header.about")}</Link>
                    </li>
                    <li>
                      <Link to="/rooms">{t("header.rooms")}</Link>
                    </li>
                    <li>
                      <Link to="/gallery">{t("header.gallery")}</Link>
                    </li>
                    <li>
                      <Link to="/contact">{t("header.contact")}</Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
